module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no7-44b0a6d8164db8f550278a3588060857.png";